// app/frontend/controllers/video_inline_player_controller.ts
import { Controller } from "@hotwired/stimulus";

/**
 * Inline video player that shows a poster frame and replaces it
 * with a Video.js player on click.
 *
 * data-video-inline-player-src-value: the video URL to play
 * Targets: poster (the poster image + play button), player (the video-player wrapper), video (the <video> element)
 */
export default class extends Controller {
  static targets = ["poster", "player", "video"];
  static values = { src: String };

  declare readonly posterTarget: HTMLElement;
  declare readonly playerTarget: HTMLElement;
  declare readonly videoTarget: HTMLVideoElement;
  declare srcValue: string;

  play(): void {
    // Hide poster, show player
    this.posterTarget.classList.add("hidden");
    this.playerTarget.classList.remove("hidden");

    // Set source and play
    this.videoTarget.src = this.srcValue;
    this.videoTarget.play();
  }
}
